import React, { useState, useEffect } from "react";
import { Paper, Typography, Grid, Button } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";

const useStyles = makeStyles(() => ({
  // formContainer: {
  //   maxWidth: "600px",
  //   margin: "auto",
  //   padding: "20px",
  //   marginTop: "40px",
  //   borderRadius: "8px",
  //   boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  // },
  // label: {
  //   fontWeight: "bold",
  //   marginBottom: "8px",
  // },
  // value: {
  //   marginBottom: "16px",
  // },
  // buttonGroup: {
  //   display: "flex",
  //   justifyContent: "flex-end",
  //   marginTop: "20px",
  // },
}));

const ViewUser = () => {
  const { classes } = useStyles();
  const navigate = useNavigate();
  const { userId } = useParams();
  const [user, setUser] = useState(null);
  const [loadingData, setLoadingData] = useState(true);

  useEffect(() => {
    const fetchUserData = async () => {
      const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
      try {
        const token = localStorage.getItem("userToken");
        const headers = { Authorization: `Bearer ${token}` };

        const response = await axios.post(`${API_BASE_URL}/user/get-user-by-id`, { userId }, { headers });

        if (response?.data?.status === "SUCCESS") {
          setUser(response.data.user);
        } else {
          Swal.fire({
            title: "Error",
            text: response?.data?.message || "Failed to fetch user details.",
            icon: "error",
            confirmButtonText: "Close",
          });
        }
      } catch (error) {
        Swal.fire({
          title: "Error",
          text: "An error occurred while fetching user details.",
          icon: "error",
          confirmButtonText: "Close",
        });
        console.error("Error fetching user data:", error);
      } finally {
        setLoadingData(false);
      }
    };

    fetchUserData();
  }, [userId]);

  if (loadingData) {
    return <Typography>Loading user data...</Typography>;
  }

  if (!user) {
    return <Typography>No user data found.</Typography>;
  }

  return (
    <Paper className="formContainer_add">
      <Typography variant="h5" gutterBottom>
        View User
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography className="label_add">Name</Typography>
          <Typography className="value_add">{user?.name}</Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography className="label_add">Email</Typography>
          <Typography className="value_add">{user?.email}</Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography className="label_add">Mobile</Typography>
          <Typography className="value_add">{user?.mobile}</Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography className="label_add">Date of Birth</Typography>
          <Typography className="value_add">{new Date(user?.dob).toLocaleDateString()}</Typography>
        </Grid>
      </Grid>
      <div className="buttonGroup_add">
        <Button
          variant="outlined"
          onClick={() => navigate("/user-list")}
        >
          Back to User List
        </Button>
      </div>
    </Paper>
  );
};

export default ViewUser;
